'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types = require('../../modules/Home/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translateHighlightedJob = function translateHighlightedJob(_ref) {
  var title = _ref.title,
      salaryRange = _ref.salaryRange,
      careerLevel = _ref.careerLevel,
      education = _ref.education,
      image = _ref.image,
      imageAlt = _ref.imageAlt,
      slug = _ref.slug;
  return {
    title: title,
    salaryRange: salaryRange,
    careerLevel: careerLevel,
    educationRequirement: education,
    image: image,
    imageAlt: imageAlt,
    slug: slug
  };
};

var translateCallToAction = function translateCallToAction(_ref2) {
  var title = _ref2.title,
      subtext = _ref2.subtext,
      icon = _ref2.icon,
      iconAlt = _ref2.iconAlt,
      buttonText = _ref2.buttonText,
      buttonAltSubtext = _ref2.buttonAltSubtext,
      href = _ref2.href,
      image = _ref2.image,
      imageAlt = _ref2.imageAlt;

  return {
    title: title,
    subtext: subtext,
    icon: icon,
    iconAlt: iconAlt,
    image: image,
    imageAlt: imageAlt,
    link: {
      label: buttonText,
      buttonAltSubtext: buttonAltSubtext,
      href: href
    }
  };
};

var translateMatchMe = function translateMatchMe(_ref3) {
  var title = _ref3.title,
      subtext = _ref3.subtext,
      buttonTitle = _ref3.buttonTitle,
      buttonSubtext = _ref3.buttonSubtext,
      buttonAltSubtext = _ref3.buttonAltSubtext,
      icon = _ref3.icon,
      iconAlt = _ref3.iconAlt,
      image = _ref3.image,
      imageAlt = _ref3.imageAlt;
  return {
    title: title,
    subtext: subtext,
    buttonTitle: buttonTitle,
    buttonSubtext: buttonSubtext,
    buttonAltSubtext: buttonAltSubtext,
    icon: icon,
    iconAlt: iconAlt,
    image: image,
    imageAlt: imageAlt
  };
};

var getBlankCallToAction = function getBlankCallToAction() {
  return translateCallToAction({
    title: '',
    subtext: '',
    icon: '',
    iconAlt: '',
    image: '',
    imageAlt: '',
    buttonText: '',
    buttonAltSubtext: '',
    href: ''
  });
};

//const getBlankHighlightedJob = () => translateHighlightedJob({
//title: '',
//salaryRange: '',
//careerLevel: '',
//education: '',
//image: '',
//imageAlt: '',
//});

var initialState = exports.initialState = {
  loaded: false,
  callToActions: [getBlankCallToAction(), getBlankCallToAction()],
  highlightedJobs: [
    //getBlankHighlightedJob(),
    //getBlankHighlightedJob(),
    //getBlankHighlightedJob(),
    //getBlankHighlightedJob(),
    //getBlankHighlightedJob(),
  ],
  matchMe: translateMatchMe({
    title: '',
    subtext: '',
    buttonTitle: '',
    buttonSubtext: '',
    buttonAltSubtext: '',
    image: '',
    imageAlt: '',
    icon: '',
    iconAlt: ''
  })
};

var translateHome = function translateHome(_ref4) {
  var callToActions = _ref4.callToActions,
      highlightedJobs = _ref4.highlightedJobs,
      matchMe = _ref4.matchMe;

  var matchMeFirstElement = matchMe[0];
  //const fakeHighlights = highlightedJobs.map(translateHighlightedJob);
  return {
    loaded: true,
    callToActions: callToActions.map(translateCallToAction),
    //highlightedJobs: new Array(10).fill(0).reduce((arr) => {
    //return arr.concat(fakeHighlights.map((h, key) => {
    //const title = `${key + arr.length}-${h.title}`;
    //console.log('title', title, key);
    //return {
    //...h,
    //title,
    //};
    //}));
    //}, []),
    highlightedJobs: highlightedJobs.map(translateHighlightedJob),
    matchMe: translateMatchMe(matchMeFirstElement)
  };
};

var reducer = (0, _defineProperty3.default)({}, _types.GET_HOME, {
  FULFILLED: function FULFILLED(state, _ref5) {
    var response = _ref5.response;

    return translateHome(response);
  },
  REJECTED: function REJECTED(state, action) {
    if (action.error && action.error.message.indexOf('Invalid JSON from') !== -1) {
      return {
        error: action.error.message
      };
    }

    return {
      error: 'Unknown error'
    };
  }
});

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/pages/home.js
// module id = 1290
// module chunks = 0